import { FieldType, FieldValue, FilterField, Filters, O, option } from "../../../../../features/ui"
import { useEffect, useState } from "react"
import { DataType } from '../../../../../tables'
import { useAdministrationHooks } from "../../../hooks/administrationHooks"
import { CashFund, CashFundType } from "../../../state/types"
import { Labels } from "../../../../../features/data-types"

type Props = {
    cashFunds: CashFund[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'cashFund'

export const CashFundFilters = (props: Props) => {
    const { cashFunds, onSearchStart, onSearchDone } = props

    const [searchText, setSearchText] = useState<string>()
    const [type, setType] = useState<CashFundType>()
    const [amountFrom, setAmountFrom] = useState<number>()
    const [amountTo, setAmountTo] = useState<number>()

    const { searchCashFunds } = useAdministrationHooks()

    useEffect(() => search(searchText, type), [cashFunds])

    const search = (
        searchTextParam?: string,
        typeParam?: CashFundType,
        amountFromParam?: number,
        amountToParam?: number
    ) => {
        onSearchStart()
        let cashFundList = cashFunds.filter(cashFund => !typeParam || cashFund.type === typeParam)
        cashFundList = amountFromParam ? cashFundList.filter(cashFund => cashFund.availableAmount >= amountFromParam) : cashFundList
        cashFundList = amountToParam ? cashFundList.filter(cashFund => cashFund.availableAmount <= amountToParam) : cashFundList
        cashFundList = searchCashFunds(cashFundList, searchTextParam)
        setTimeout(() => onSearchDone(cashFundList), 100)
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText, type)
    }

    const onChangeType = (value?: FieldValue) => {
        const newType = value as O<CashFundType>
        if (newType !== type) {
            setType(newType)
            search(searchText, newType)
        }
    }

    const onChangeAmountFrom = (value?: FieldValue) => {
        const newAmountFrom = (value || 0) as number
        setAmountFrom(newAmountFrom)
        search(searchText, type, newAmountFrom, amountTo)
    }

    const onChangeAmountTo = (value?: FieldValue) => {
        const newAmountTo = value as O<number>
        setAmountTo(newAmountTo)
        search(searchText, type, amountFrom, newAmountTo)
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por nombre o tipo',
        icon: 'search',
        onChange: handleSearch
    }

    const filterFields: FilterField[] = [
        {
            name: 'type',
            type: FieldType.SELECT,
            options: Object.values(CashFundType).map(type => option(type, Labels.cashFundTypeLabel(type))),
            label: 'Tipo',
            space: 3,
            onChange: onChangeType
        },
        {
            name: 'amountFrom',
            type: FieldType.NUMBER,
            label: 'Disponible: Desde',
            max: amountTo,
            space: 2,
            onChange: onChangeAmountFrom
        },
        {
            name: 'amountTo',
            type: FieldType.NUMBER,
            label: 'Disponible: Hasta',
            min: amountFrom,
            space: 2,
            onChange: onChangeAmountTo
        }
    ]

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
            fields={filterFields}
        />
    )
}
